import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuditHistoryVm } from './../generated/Models/AuditHistoryVm';
import { TableComponent } from '../table/table.component';
import { GlobalVariablesService } from '../../services/global-variables.service';
import { NavigationService } from '../navigation/navigation.service';
import { SecurityService } from '../../core/security/security.service';
import { PermissionProfileEnum } from '../../core/enums/generated/PermissionProfileEnum';
import { UserJsVm } from '../generated/Admin/Models/User/UserJsVm';
import { SystemMessageService } from '../../core/system-message/system-message-service';
import { NotificationService } from '../../services/notification.service';

@Component({
    selector: 'pcg-shared-audit-history',
    templateUrl: './audit-history.component.html',
    styleUrls: ['./audit-history.component.scss'],
    standalone: false
})
export class AuditHistoryComponent implements OnInit {

	@ViewChild(TableComponent, { static: true }) table: TableComponent<AuditHistoryVm>;

	@Input() id: number;
    @Input() viewModel: string;
    @Input() auditHistoryName: string;
	@Input() clientName = "";
	@Input() integrationName = "";

	user: UserJsVm;
	columns = AuditHistoryVm.ColumnDefs;

	auditName: string = "";
	filters = {
		id: 0
		, viewModel: null!
		, auditName: null!
	};

	constructor(
		private activatedRoute: ActivatedRoute
		, public gvs: GlobalVariablesService
		, public nav: NavigationService
		, public sec: SecurityService
		, public messageService: SystemMessageService
		, public router: Router
		, private ns: NotificationService
	) { }

	ngOnInit() {
		this.user = this.sec.getUser();
		
        if (
			this.id 
			&& this.viewModel 
			&& this.auditHistoryName
		) {
            this.filters.id = this.id;
            this.filters.viewModel = this.viewModel;
            this.filters.auditName = this.auditHistoryName;
        } else { this.getFiltersFromLocalStorage(); }

		if (this.filters.auditName === "Client Detail") { this.checkSecurity(); }
		if (this.clientName !== "") { 
			if (this.user.clientId === this.id) { this.gvs.clientName.set(this.clientName); }
			else { this.gvs.sysAdminClientName.set(this.clientName); }
		}
		if (this.integrationName !== "") { this.gvs.integrationName.set(this.integrationName); }
    }

	getFiltersFromLocalStorage() {
		this.filters.id = this.activatedRoute.snapshot.params['id'];
		this.filters.viewModel = localStorage?.getItem('vmType');
		this.filters.auditName = localStorage?.getItem('auditName');

		if (this.filters.auditName === "Client Detail") { this.nav.setOpenSecondaryMenu(['Admin', 'Settings', 'Audit History']); }
		if (this.filters.auditName === "Integration Detail") { this.nav.setOpenSecondaryMenu(['SysAdmin', 'Integrations', 'Audit History']); }
	}

	checkSecurity() {
		if (this.sec.getSecurity()?.permissionProfile === PermissionProfileEnum.Admin) {
			if (this.user.clientId != this.filters.id) {
				this.router.navigateByUrl('dashboard');
				this.ns.showError("Access Denied. You do not have sufficient permission level.", { timeOut: 5000 });
			}
		}
	}

	setClientName(event) {
		if (
			event?.value?.clientName !== "" 
			&& this.filters.auditName === "Client Detail"
		) { this.gvs.clientName.set(event.value.clientName); }
		if (event?.value?.integrationName !== "") { this.gvs.integrationName.set(event.value.integrationName); }
		if (
			this.filters.auditName === "Global NDC" 
			&& event?.value?.clientName !== ""
		) { this.auditName = event.value.clientName; } 
		else { this.auditName = ""; }
	}
}